<template>
  <el-button 
    class="cat-button"
    type="primary"
    @click="handleclick"
  >
    <span v-if="$slots.default"> <slot /></span>
  </el-button>
</template>

<script>
export default {
   name: "ButtonSearch",
   methods: {
    handleclick(e) {
      this.$emit("click", e);
    }
   }

}
</script>

<style>

</style>
